<form [formGroup]="DocumentForm" novalidate>
    <div class="container border border-success rounded mt-2">
        <div class="container">
            <div class="card border border-success mt-3">
                <h5 class="card-header">Adjuntar Documentos
                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#Doc" role="button"
                        aria-expanded="true" aria-controls="Doc"></a>
                </h5>
                <div class="collapse show" id="Doc">
                    <div class="card-body">
                        <div class="alert " role="alert" *ngIf="inforamar" [ngClass]="{'alert-info':true}">
                            <h4 class="alert-heading">{{titulo}}</h4>
                            <hr>
                            <p class="mb-0" id="txtbody">{{body}}</p>
                            <app-progress *ngIf="progress || !datosCargados"></app-progress>
                        </div>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Documento</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="nfile1!==''">
                                    <th scope="row">{{nfile1}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file01.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile1">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue1 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl1"
                                            [ngClass]="{'d-none': Pfile1}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto1)">
                                            <input id="fl1" type="file" style="display:none"
                                                (change)="Sfile1($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file1">
                                            {{this.file1.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto1?.Value | estadonota}}</td>
                                    <td>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto1) && DocumentForm.controls.file01.value ==''"
                                            type="button" class="btn btn-primary btn-lg btn-sm"
                                            (click)="SendFile1()">Enviar</button>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto1) && DocumentForm.controls.file01.value !==''"
                                            type="button" class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile1()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile2!==''">
                                    <th scope="row">{{nfile2}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file02.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile2">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue2 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl2"
                                            [ngClass]="{'d-none': Pfile2}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto2)">
                                            <input id="fl2" type="file" style="display:none"
                                                (change)="Sfile2($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file2">
                                            {{this.file2.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto2?.Value | estadonota}}</td>
                                    <td>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto2) && DocumentForm.controls.file02.value ==''"
                                            type="button" class="btn btn-primary btn-lg btn-sm"
                                            (click)="SendFile2()">Enviar</button>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto2) && DocumentForm.controls.file02.value !==''"
                                            type="button" class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile2()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile3!==''">
                                    <th scope="row">{{nfile3}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file03.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile3">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue3 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl3"
                                            [ngClass]="{'d-none': Pfile3}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto3)">
                                            <input id="fl3" type="file" style="display:none"
                                                (change)="Sfile3($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file3">
                                            {{this.file3.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto3?.Value | estadonota}}</td>
                                    <td>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto3) && DocumentForm.controls.file03.value ==''"
                                            type="button" class="btn btn-primary btn-lg btn-sm"
                                            (click)="SendFile3()">Enviar</button>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto3) && DocumentForm.controls.file03.value !==''"
                                            type="button" class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile3()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile4!==''">
                                    <th scope="row">{{nfile4}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file04.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile4">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue4 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl4"
                                            [ngClass]="{'d-none': Pfile4}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto4)">
                                            <input id="fl4" type="file" style="display:none"
                                                (change)="Sfile4($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file4">
                                            {{this.file4.name}}</span>
                                    <td>{{DocusCRM.EstadoDocto4?.Value | estadonota}}</td>
                                    <td>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto4) && DocumentForm.controls.file04.value ==''"
                                            type="button" class="btn btn-primary btn-lg btn-sm"
                                            (click)="SendFile4()">Enviar</button>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto4) && DocumentForm.controls.file04.value !==''"
                                            type="button" class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile4()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile5!==''">
                                    <th scope="row">{{nfile5}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file05.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile5">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue5 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl5"
                                            [ngClass]="{'d-none': Pfile5}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto5)">
                                            <input id="fl5" type="file" style="display:none"
                                                (change)="Sfile5($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file5">
                                            {{this.file5.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto5?.Value | estadonota}}</td>
                                    <td>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto5) && DocumentForm.controls.file05.value == ''"
                                            type="button" class="btn btn-primary btn-lg btn-sm"
                                            (click)="SendFile5()">Enviar</button>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto5) && DocumentForm.controls.file05.value !== ''"
                                            type="button" class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile5()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile6!==''">
                                    <th scope="row">{{nfile6}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file06.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile6">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue6 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl6"
                                            [ngClass]="{'d-none': Pfile6}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto6)">
                                            <input id="fl6" type="file" style="display:none"
                                                (change)="Sfile6($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file6">
                                            {{this.file6.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto6?.Value | estadonota}}</td>
                                    <td>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto6) && DocumentForm.controls.file06.value == ''"
                                            type="button" class="btn btn-primary btn-lg btn-sm"
                                            (click)="SendFile6()">Enviar</button>
                                        <button
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto6) && DocumentForm.controls.file06.value !== ''"
                                            type="button" class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile6()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile7!==''">
                                    <th scope="row">{{nfile7}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file07.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile7">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue7 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl7"
                                            [ngClass]="{'d-none': Pfile7}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto7)">
                                            <input id="fl7" type="file" style="display:none"
                                                (change)="Sfile7($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file7">
                                            {{this.file7.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto7?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto7) && DocumentForm.controls.file07.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile7()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto7) && DocumentForm.controls.file07.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile7()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile8!==''">
                                    <th scope="row">{{nfile8}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file08.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile8">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue8 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl8"
                                            [ngClass]="{'d-none': Pfile8}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto8)">
                                            <input id="fl8" type="file" style="display:none"
                                                (change)="Sfile8($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file8">
                                            {{this.file8.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto8?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto8) && DocumentForm.controls.file08.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile8()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto8) && DocumentForm.controls.file08.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile8()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile9!==''">
                                    <th scope="row">{{nfile9}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file09.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile9">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue9 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl9"
                                            [ngClass]="{'d-none': Pfile9}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto9)">
                                            <input id="fl9" type="file" style="display:none"
                                                (change)="Sfile9($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file9">
                                            {{this.file9.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto9?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto9) && DocumentForm.controls.file09.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile9()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto9) && DocumentForm.controls.file09.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile9()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile10!==''">
                                    <th scope="row">{{nfile10}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file10.hasError('required')">*obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile10">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue10 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl10"
                                            [ngClass]="{'d-none': Pfile10}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto10)">
                                            <input id="fl10" type="file" style="display:none"
                                                (change)="Sfile10($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file10">
                                            {{this.file10.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto10?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto10) && DocumentForm.controls.file10.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile10()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto10) && DocumentForm.controls.file10.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile10()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile11!==''">
                                    <th scope="row">{{nfile11}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file11.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile11">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue11 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl11"
                                            [ngClass]="{'d-none': Pfile11}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto11)">
                                            <input id="fl11" type="file" style="display:none"
                                                (change)="Sfile11($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file11">
                                            {{this.file11.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto11?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto11) && DocumentForm.controls.file11.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile11()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto11) && DocumentForm.controls.file11.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile11()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile12!==''">
                                    <th scope="row">{{nfile12}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file12.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile12">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue12 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl12"
                                            [ngClass]="{'d-none': Pfile12}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto12)">
                                            <input id="fl12" type="file" style="display:none"
                                                (change)="Sfile12($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file12">
                                            {{this.file12.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto12?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto12) && DocumentForm.controls.file12.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile12()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto12) && DocumentForm.controls.file12.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile12()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile13!==''">
                                    <th scope="row">{{nfile13}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file13.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile13">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue13 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl13"
                                            [ngClass]="{'d-none': Pfile13}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto13)">
                                            <input id="fl13" type="file" style="display:none"
                                                (change)="Sfile13($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file13">
                                            {{this.file13.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto13?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto13) && DocumentForm.controls.file13.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile13()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto13) && DocumentForm.controls.file13.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile13()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile14!==''">
                                    <th scope="row">{{nfile14}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file14.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile14">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue14 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl14"
                                            [ngClass]="{'d-none': Pfile14}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto14)">
                                            <input id="fl14" type="file" style="display:none"
                                                (change)="Sfile14($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file14">
                                            {{this.file14.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto14?.Text | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto14) && DocumentForm.controls.file14.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile14()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto14) && DocumentForm.controls.file14.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile14()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile15!==''">
                                    <th scope="row">{{nfile15}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file15.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile15">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue15 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl15"
                                            [ngClass]="{'d-none': Pfile15}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto15)">
                                            <input id="fl15" type="file" style="display:none"
                                                (change)="Sfile15($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file15">
                                            {{this.file15.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto15?.Value | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto15) && DocumentForm.controls.file15.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile15()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto15) && DocumentForm.controls.file15.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile15()'>Actualizar</button>
                                    </td>
                                </tr>
                                <tr *ngIf="nfile16!==''">
                                    <th scope="row">{{nfile16}}
                                        <span class="text-danger"
                                            *ngIf="DocumentForm.controls.file16.hasError('required')">*
                                            obligatorio</span>
                                    </th>
                                    <td>
                                        <div class="progress" *ngIf="Pfile16">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar" [style.width]="Pvalue16 + '%'"></div>
                                        </div>
                                        <label class="btn btn btn-outline-primary btn-sm" for="fl16"
                                            [ngClass]="{'d-none': Pfile16}"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto16)">
                                            <input id="fl16" type="file" style="display:none"
                                                (change)="Sfile16($event.target.files[0])">
                                            <span> Adjuntar </span>
                                        </label>
                                        <span class='label label-info' id="upload-file-info" *ngIf="this.file16">
                                            {{this.file16.name}}</span>
                                    </td>
                                    <td>{{DocusCRM.EstadoDocto16?.Text | estadonota}}</td>
                                    <td>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto16) && DocumentForm.controls.file16.value == ''"
                                            class="btn btn-primary btn-lg btn-sm" (click)="SendFile16()">Enviar</button>
                                        <button type="button"
                                            *ngIf="PermiteAdjuntar(DocusCRM.EstadoDocto16) && DocumentForm.controls.file16.value !== ''"
                                            class="btn btn-success btn-lg btn-sm ml-1"
                                            (click)='UpdateFile16()'>Actualizar</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-2 mt-2" *ngIf="DocumentForm.valid">
        <div class="col-md-3">&nbsp;</div>

        <div class="col-md-6 ml-2">
            <app-apibutton text="Guardar y continuar" [progress]="sending" (click)="comprobar_y_avanzar()"
                *ngIf="changeDocumentosCount === 0 && faseActual === '4'"></app-apibutton>
            <app-apibutton text="Confirmar documentos" [progress]="sending" (click)="goToMatricula()"
                *ngIf="changeDocumentosCount > 0 && faseActual === '7'"></app-apibutton>
        </div>
        <div class="col-md-3">&nbsp;</div>
    </div>
</form>

<!-- Modal Bloqueo Financiero -->
<div class="modal fade" id="modalBloqueoFinanciero" tabindex="-1" aria-labelledby="modalBloqueoFinancieroLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <p class="text-left">Estimado(a) estudiante,</p>
                <p class="text-left">
                    Nuestros sistemas indican que existe una situación financiera que es
                    necesaria aclarar y, eventualmente pagar o pactar, para poder realizar
                    una nueva matrícula. Te agradeceríamos tomar contacto con el área
                    financiera de la sede en la que estudiaste anteriormente para
                    profundizar la situación.
                </p>
                <p class="text-left">
                    Si necesitas información de contacto de nuestras Sedes, podrás
                    obtenerla en
                    <a href="http://www.santotomas.cl/contactossedes.html"
                        class="text-primary">http://www.santotomas.cl/contactossedes.html</a>
                </p>
                <p class="text-left">
                    Atentamente, <br />
                    Dirección de Admisión, Santo Tomás.
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Modal Bloqueo Financiero -->

<!-- Modal Bloqueo Académico -->
<div class="modal fade" id="modalBloqueoAcademico" tabindex="-1" aria-labelledby="modalBloqueoAcademicoLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <p class="text-left text-danger font-weight-bold">
                    Usted presenta una restricción para continuar con el proceso de
                    matrícula del programa seleccionado, es por ello que se le presentan
                    las siguientes opciones:
                </p>
                <div class="btn-toolbar text-center d-flex justify-content-around">
                    <button type="button" class="btn btn-primary btn-opciones" style="width: 31%"
                        (click)="redirigirAlInicio()">
                        Ir al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal Bloqueo Académico -->


<!-- Modal Vacantes -->
<div class="modal fade" id="modalVacantes" tabindex="-1" aria-labelledby="modalVacantesLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <p class="text-left text-danger font-weight-bold">
                    No quedan vacantes para esta carrera / sede, por ende tiene disponible
                    las siguientes opciones:
                </p>
                <div class="btn-toolbar text-center d-flex justify-content-around">
                    <button type="button" class="btn btn-primary btn-opciones" style="width: 31%" (click)="contactar()">
                        Contáctenme si hay vacantes
                    </button>
                    <button type="button" class="btn btn-primary btn-opciones" style="width: 31%"
                        (click)="redirigirAlInicio()">
                        Ir al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal Vacantes -->
